import React, { useState, useEffect, lazy, Suspense } from "react";
import { useTestContext } from "../context/TestContext";

// Imports
import TitleText from "./TitleText";
//import Pagination from "./Pagination";
const ProductCard = lazy(() => import("./ProductCard"));

const DiagnosticTests = () => {
  const { fetchProducts, allProducts, paginationInfo, popularProducts } =
    useTestContext();
  const [currentPage, setCurrentPage] = useState(1);

 const filteredProducts = popularProducts
  .filter(
    (product) =>
      product.productType === "Pathology Test" || product.productType === "test"
  )
  .sort((a, b) => {
    const cleanBrandA = a.brandName.replace(/[\r\n]+/g, '').trim();
    const cleanBrandB = b.brandName.replace(/[\r\n]+/g, '').trim();

    const isDrLalA = cleanBrandA === "Dr Lal PathLabs";
    const isDrLalB = cleanBrandB === "Dr Lal PathLabs";

    // Prioritize "Dr Lal PathLabs"
    if (isDrLalA && !isDrLalB) return -1;
    if (!isDrLalA && isDrLalB) return 1;

    // Then sort by price ascending
    const priceA = parseFloat(a.sellingPrice.replace(/,/g, ''));
    const priceB = parseFloat(b.sellingPrice.replace(/,/g, ''));
    return priceA - priceB;
  });



  useEffect(() => {
    fetchProducts(currentPage);
  }, [currentPage]);

  return (
    <div className="w-full h-fit bg-whiteColor flex flex-col justify-start items-center p-[3%] lg:p-[2%] space-y-[5%] lg:space-y-[2%]">
      <TitleText text="Most Prescribed Diagnostic Tests" />
      <div className="w-[90%] h-fit grid grid-cols-1 lg:grid-cols-3 gap-x-0 gap-y-3 lg:gap-y-10 mx-auto justify-items-center lg:px-[0.8%]">
        <Suspense
          fallback={
            <div className="w-full h-fit flex justify-center items-center">
              <span className="font-normal text-[7.5vw] lg:text-[1.25vw] text-textPrimaryColor">
                Loading products...
              </span>
            </div>
          }
        >
          {filteredProducts?.map((item, index) => (
            <ProductCard data={item} key={index} />
          ))}
        </Suspense>
      </div>
    </div>
  );
};

export default DiagnosticTests;
